(function () {
  'use strict';

  if (window.NadotecProductLabels) {
    window.NadotecProductLabels.refresh();
    return;
  }

  var scheduledRefresh = null;
  var maximumTimeout = 2147483647;

  function timestampInMilliseconds(value) {
    if (!value) return null;

    var seconds = Number(value);
    return Number.isFinite(seconds) ? seconds * 1000 : null;
  }

  function updateLabels() {
    var now = Date.now();
    var nextChange = null;

    document.querySelectorAll('[data-product-label]').forEach(function (label) {
      var start = timestampInMilliseconds(label.dataset.start);
      var end = timestampInMilliseconds(label.dataset.end);

      var isActive =
        (start === null || now >= start) &&
        (end === null || now <= end);

      label.hidden = !isActive;

      if (
        start !== null &&
        now < start &&
        (nextChange === null || start < nextChange)
      ) {
        nextChange = start;
      }

      if (
        end !== null &&
        now <= end &&
        (nextChange === null || end < nextChange)
      ) {
        nextChange = end + 1;
      }
    });

    window.clearTimeout(scheduledRefresh);

    if (nextChange !== null) {
      scheduledRefresh = window.setTimeout(
        updateLabels,
        Math.min(
          Math.max(nextChange - now, 1),
          maximumTimeout
        )
      );
    }
  }

  var observer = new MutationObserver(function (mutations) {
    var containsNewLabels = mutations.some(function (mutation) {
      return Array.prototype.some.call(
        mutation.addedNodes,
        function (node) {
          return (
            node.nodeType === 1 &&
            (
              node.matches('[data-product-label]') ||
              node.querySelector('[data-product-label]')
            )
          );
        }
      );
    });

    if (containsNewLabels) {
      updateLabels();
    }
  });

  window.NadotecProductLabels = {
    refresh: updateLabels
  };

  function initialize() {
    updateLabels();

    observer.observe(document.documentElement, {
      childList: true,
      subtree: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initialize,
      { once: true }
    );
  } else {
    initialize();
  }
})();